import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(({ variables, palette, breakpoints }) => ({
  pageTypeSwitchContent:{
    '& .switch-description':{ 
      marginBottom:variables?.spacingE,
      paddingLeft:variables?.spacingD,
      paddingRight:variables?.spacingD
    },
    '& .segmented-control-container':{
        width:'auto',
        maxWidth:'428px',
        [breakpoints.down('xs')]: {
          width:'328px',
        },
        margin:'0 auto',
        '& .segmentIcon': {
            // fontWeight:'bold !important',
            position:'relative',
            top:'1px',
            marginRight:variables?.spacingA,
            '&.selected':{ 
                color: palette?.jet?.contentBrand
            }
        }
    }
  },
}));

export default useStyles;
